import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Services = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Services Provided</h3>

      <p>
        Yoda Safety Services provides workplace safety training, digital safety
        tools, documentation, products, and related services. Depending on the
        services available to you, these may include:
      </p>

      <ul>
        <li>
          <strong>Online Training:</strong> Access to workplace safety courses,
          training materials, quizzes, assessments, course progress tracking,
          completion records, and certificates.
        </li>
        <li>
          <strong>Individual Accounts:</strong> Account functionality that
          allows users to access assigned or purchased training, manage
          available account information, complete courses and assessments, and
          access applicable training records and certificates.
        </li>
        <li>
          <strong>Company Accounts and Training Management:</strong> Tools that
          allow authorized company managers or representatives to manage users,
          purchase and assign training, monitor training progress and
          completion, review applicable results, and access training records and
          certificates associated with users under their company account.
        </li>
        <li>
          <strong>Digital Safety Forms:</strong> Access to digital workplace
          safety forms and tools for completing, submitting, storing, viewing,
          and managing form entries, subject to applicable account roles and
          permissions.
        </li>
        <li>
          <strong>Safety Manuals and Documentation:</strong> Access to safety
          manuals, workplace documentation, and other resources made available
          through the platform, subject to applicable subscriptions,
          permissions, or service arrangements.
        </li>
        <li>
          <strong>Subscription Services:</strong> Access to certain platform
          features, forms, manuals, documentation, or other resources that may
          be provided on a subscription basis.
        </li>
        <li>
          <strong>Authorized Subcontractor Access:</strong> Limited access to
          designated forms, manuals, or other resources where permission has
          been granted through an applicable company account.
        </li>
        <li>
          <strong>Safety Products and Related Services:</strong> Information and
          inquiries relating to workplace safety products and other services
          offered by Yoda Safety Services. Certain products or services may
          require customers to contact Yoda Safety Services directly to arrange
          a purchase or obtain additional information.
        </li>
        <li>
          <strong>Custom Documentation and Safety Services:</strong> Custom
          safety documentation and other workplace safety services that may be
          provided under separate arrangements or service requirements.
        </li>
        <li>
          <strong>Communications:</strong> Service-related communications,
          training notifications, account communications, and optional
          newsletters or promotional communications.
        </li>
        <li>
          <strong>Payment Processing:</strong> Payment processing for eligible
          online purchases through Stripe or another authorized third-party
          payment processor.
        </li>
      </ul>

      <h4>Modifications to Services</h4>

      <p>
        Yoda Safety Services may modify, update, replace, suspend, or
        discontinue features, content, courses, products, or services from time
        to time. This may include changes to course content, platform
        functionality, pricing, subscriptions, availability, or technical
        requirements.
      </p>

      <p>
        Where a change materially affects a paid service or existing
        subscription, we will provide notice where reasonably appropriate or
        required by applicable law or an applicable agreement.
      </p>

      <h4>Service Availability</h4>

      <p>
        We aim to maintain reliable access to our website and platform; however,
        we do not guarantee that any service will be available without
        interruption or error. Access may be temporarily limited or unavailable
        due to maintenance, updates, technical issues, third-party service
        interruptions, security requirements, or circumstances beyond our
        reasonable control.
      </p>

      <h4>User Technical Requirements</h4>

      <p>
        Users are responsible for maintaining the equipment, software, internet
        connection, and compatible technology reasonably required to access and
        use the platform. Yoda Safety Services is not responsible for access
        issues caused by a user&apos;s equipment, software, internet connection,
        browser, device settings, or other systems outside our reasonable
        control.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Services;
